const akkordeons = document.querySelectorAll('.ce_rsce_akkordeon');

if (akkordeons) {
    akkordeons.forEach(akkordeon => {
        let questions = akkordeon.querySelectorAll('.question');
        questions.forEach(question => {
            question.addEventListener('click', () => {
                question.parentElement.classList.toggle('active');
            });
        });
    });
}
